// new custom js stsrta from here

$(document).ready(function(){
   $('.product_media_slider_main').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: '.thumb_next_main',
    prevArrow: '.thumb_prev_main',
    asNavFor: '.product_media_slider_thumb',
     responsive: [
      {
        breakpoint: 749,
        settings: {       
          slidesToShow: 1,
          centerMode: true,
          infinite: false,
          centerPadding: '40px',
          arrows: false,
          dots:true
        },
      },
       {
        breakpoint: 576,
        settings: {       
          slidesToShow: 1,
          centerMode: true,
          infinite: false,
          centerPadding: '10px',
          arrows: false,
          dots:true
        },
      }
    ],
  });
  $('.product_media_slider_thumb').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.product_media_slider_main',
    dots: false,
    infinite:false,
    arrows: false,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 749,
        settings: {
          arrows: false
        },
      },
    ],
  });
})